module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/axios/index.js
// module id = 63
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14